module.exports = __webpack_public_path__ + "img/flight_land.03cc1f0b.svg";